import { fetchThemes, type ThemeFetchParams } from '@/entities/insight';
import { useQuery } from '@tanstack/react-query';

export function useThemes(params: ThemeFetchParams) {
  return useQuery({
    queryKey: [
      'themes',
      params.queryId,
      params.startDate,
      params.endDate,
      params.sentiment,
      params.view_by,
      params.theme,
      params.brand,
      params.limit,
      JSON.stringify(params.publicFilter),
    ],
    queryFn: ({ signal }) => fetchThemes(params, signal),
  });
}
